(() => {
  const cartWalletSelector = '#CartDrawer shopify-accelerated-checkout-cart';
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const isAppleMobile = /iPad|iPhone|iPod/.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const gap = 10;
  const layoutProperties = [
    'position',
    'inset-inline-start',
    'top',
    'width',
    'height',
    'min-width',
    'max-width',
    'margin',
    'display',
  ];

  function resetLayout(root) {
    ['position', 'display', 'height', 'min-height', 'overflow'].forEach((property) => {
      root.style.removeProperty(property);
    });

    root.querySelectorAll(':scope > [slot^="button-"]').forEach((wallet) => {
      layoutProperties.forEach((property) => wallet.style.removeProperty(property));
    });
  }

  function layoutWallets(root) {
    resetLayout(root);

    if (!mobileQuery.matches || !isAppleMobile) return;

    const googlePay = root.querySelector(':scope > shopify-google-pay-button');
    googlePay?.style.setProperty('display', 'none', 'important');

    const wallets = Array.from(root.querySelectorAll(':scope > [slot^="button-"]')).filter(
      (wallet) => wallet !== googlePay
    );

    if (!wallets.length) return;

    const rootRect = root.getBoundingClientRect();
    const walletRects = wallets.map((wallet) => wallet.getBoundingClientRect());
    const count = wallets.length;
    const walletWidth = (rootRect.width - gap * (count - 1)) / count;

    root.style.setProperty('position', 'relative', 'important');
    root.style.setProperty('display', 'block', 'important');
    root.style.setProperty('height', '42px', 'important');
    root.style.setProperty('min-height', '42px', 'important');
    root.style.setProperty('overflow', 'visible', 'important');

    wallets.forEach((wallet, index) => {
      const targetStart = rootRect.left + index * (walletWidth + gap);
      const inlineOffset = targetStart - walletRects[index].left;
      const blockOffset = rootRect.top - walletRects[index].top;

      wallet.style.setProperty('position', 'absolute', 'important');
      wallet.style.setProperty('inset-inline-start', `${inlineOffset}px`, 'important');
      wallet.style.setProperty('top', `${blockOffset}px`, 'important');
      wallet.style.setProperty('width', `${walletWidth}px`, 'important');
      wallet.style.setProperty('height', '42px', 'important');
      wallet.style.setProperty('min-width', '0', 'important');
      wallet.style.setProperty('max-width', 'none', 'important');
      wallet.style.setProperty('margin', '0', 'important');
      wallet.style.setProperty('display', 'block', 'important');
    });
  }

  let frame;

  function scheduleLayout() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      document.querySelectorAll(cartWalletSelector).forEach(layoutWallets);
    });
  }

  new MutationObserver(scheduleLayout).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  mobileQuery.addEventListener?.('change', scheduleLayout);
  window.addEventListener('resize', scheduleLayout);
  document.addEventListener('DOMContentLoaded', scheduleLayout, { once: true });
  scheduleLayout();
})();
